webpackJsonp([1],{

/***/ 11:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initShareData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return changeURLArg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getParameter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return login; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonp__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonp__);


var title = '10000个有道词典VIP限时赠送';
var desc = '日语学习用有道，领VIP免费查新世纪日汉双解大辞典';
var imgUrl = 'https://oimageb2.ydstatic.com/image?id=2493852103049466641&product=xue';
var signId = '';

var ua = navigator.userAgent;
var ydk = window.ydk;
var isYouDao = ua.indexOf('youdao');
var isYouDaoCourse = ua.indexOf('youdaoCourse');
var isYouDaoDict = ua.indexOf('youdaodict');

var initShareData = function initShareData(link, silence) {
    ydk.share({
        title: title,
        desc: desc,
        link: link,
        imgUrl: imgUrl,
        silence: silence,
        shift: true
    });
};
var changeURLArg = function changeURLArg(url, arg, arg_val) {
    var pattern = arg + '=([^&]*)';
    var replaceText = arg + '=' + arg_val;
    if (url.match(pattern)) {
        var tmp = '/(' + arg + '=)([^&]*)/gi';
        tmp = url.replace(eval(tmp), replaceText);
        return tmp;
    } else {
        if (url.match('[\?]')) {
            return url + '&' + replaceText;
        } else {
            return url + '?' + replaceText;
        }
    }
    return url + '\n' + arg + '\n' + arg_val;
};

var setStorage = function setStorage(key, value) {
    var v = value;
    if ((typeof v === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(v)) == 'object') {
        v = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(v);
        v = 'obj-' + v;
    } else {
        v = 'str-' + v;
    }
    var ls = window.localStorage;
    if (ls) {
        ls.setItem(key, v);
    }
};
//获取缓存
var getStorage = function getStorage(key) {
    var ls = window.localStorage;
    if (ls) {
        var v = ls.getItem(key);
        if (!v) {
            return;
        }
        if (v.indexOf('obj-') === 0) {
            v = v.slice(4);
            return JSON.parse(v);
        } else if (v.indexOf('str-') === 0) {
            return v.slice(4);
        }
    }
};
var getParameter = function getParameter(name) {
    var r = new RegExp("(\\?|#|&)" + name + "=([^&#]*)(&|#|$)"),
        m = location.href.match(r);
    return decodeURIComponent(!m ? "" : m[2]);
};

var login = function login(silence) {
    ydk.isLogin({
        success: function success(res) {
            if (!res.isLogin) {
                if (isYouDao == -1) {
                    window.location.href = 'http://c.youdao.com/dict/commons/login.html?back_url=' + encodeURIComponent(window.location.href);
                } else {
                    ydk.login({
                        defer: 3000,
                        success: function success(res) {
                            __WEBPACK_IMPORTED_MODULE_2_jsonp___default()('http://webutil.youdao.com/webutil/v2/dictVIP/getEncodedUserId', function (err, data) {
                                var url = void 0;
                                var signId = data.result.signId;
                                if (!ydk.isYD) {
                                    url = changeURLArg(window.location.href, 'signId', signId);
                                } else {
                                    url = changeURLArg('http://c.youdao.com/test/oxford-activity/index.html', 'signId', signId);
                                }
                                initShareData(url, silence);
                            });
                        }
                    });
                }
            } else {
                __WEBPACK_IMPORTED_MODULE_2_jsonp___default()('http://webutil.youdao.com/webutil/v2/dictVIP/getEncodedUserId', function (err, data) {
                    var url = void 0;
                    var signId = data.result.signId;
                    if (!ydk.isYD) {
                        url = changeURLArg(window.location.href, 'signId', signId);
                    } else {
                        url = changeURLArg('http://c.youdao.com/test/oxford-activity/index.html', 'signId', signId);
                    }
                    initShareData(url, silence);
                });
            }
        }
    });
};

/***/ }),

/***/ 121:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 122:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 123:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 124:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 125:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(124)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(78),
  /* template */
  __webpack_require__(142),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(121)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(139),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(123)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(141),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(122)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(140),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 139:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.list != '') ? _c('div', {
    attrs: {
      "id": "situation"
    }
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('ul', _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('img', {
      staticClass: "head",
      attrs: {
        "src": item.avatar,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.nickname))]), _vm._v(" "), (item.type != 6) ? _c('img', {
      staticClass: "img_vip",
      attrs: {
        "src": "http://shared.youdao.com/dict/market/oxford-activity/imgs/oneVip.png",
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (item.type == 6) ? _c('img', {
      staticClass: "img_vip",
      attrs: {
        "src": "http://shared.youdao.com/dict/market/oxford-activity/imgs/sixVip.png",
        "alt": ""
      }
    }) : _vm._e()])
  }))])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title"
  }, [_c('span'), _vm._v("好友领取情况"), _c('span')])
}]}

/***/ }),

/***/ 140:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.prompt),
      expression: "prompt"
    }],
    attrs: {
      "id": "prompt"
    }
  }, [_c('div', {
    ref: "masker",
    staticClass: "mask",
    on: {
      "click": _vm.closedMask
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.save),
      expression: "save"
    }],
    attrs: {
      "src": "http://shared.youdao.com/dict/market/oxford-activity/imgs/save.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.share),
      expression: "share"
    }],
    attrs: {
      "src": "http://shared.youdao.com/dict/market/oxford-activity/imgs/share.png",
      "alt": ""
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 141:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLogin),
      expression: "showLogin"
    }],
    attrs: {
      "id": "login"
    }
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "no_login",
    on: {
      "click": _vm.closed
    }
  }, [_vm._v("不领了，谢谢")]), _vm._v(" "), _c('div', {
    staticClass: "go_login",
    on: {
      "click": _vm.goLogin
    }
  }, [_vm._v("立即领取")])])])
},staticRenderFns: []}

/***/ }),

/***/ 142:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "getCode"
    }
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('h6', [_vm._v("1万个有道词典VIP")]), _vm._v(" "), _c('h5', [_vm._v("限时赠送")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("VIP用户新世纪日汉双解大辞典免费用")]), _vm._v(" "), _c('div', {
    staticClass: "butten_list"
  }, [_c('div', {
    class: _vm.canGetOneMounthVip ? 'one_mouth_vip' : 'one_mouth_vip_no',
    on: {
      "click": _vm.getOneMounthVip
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.canGetSixMounthVip ? 'six_mouth_vip' : 'six_mouth_vip_no',
    on: {
      "click": _vm.getSixMounthVip
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    ref: "code",
    staticClass: "code",
    attrs: {
      "id": "code",
      "unselectable": "on"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.code)
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.success),
      expression: "!success"
    }],
    staticClass: "sign"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.success),
      expression: "success"
    }],
    staticClass: "prompt"
  }), _vm._v(" "), _c('prompt', {
    attrs: {
      "prompt": _vm.prompt,
      "share": _vm.share,
      "save": _vm.save,
      "getSuccess": _vm.getSuccess
    },
    on: {
      "closed": _vm.closed
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('login', {
    attrs: {
      "showLogin": _vm.showLogin
    },
    on: {
      "isLogin": _vm.isLogin
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', [_vm._v("/")]), _vm._v("VIP兑换码"), _c('span', [_vm._v("/")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('a', {
    staticClass: "open_dict",
    attrs: {
      "href": "http://a.app.qq.com/o/simple.jsp?pkgname=com.youdao.dict&ckey=CK1407861672048"
    }
  }, [_vm._v("打开有道词典")])])
}]}

/***/ }),

/***/ 143:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('img', {
    staticClass: "banner",
    attrs: {
      "src": "http://shared.youdao.com/dict/market/oxford-activity/imgs/masterBanner.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('get-code', {
    staticClass: "main",
    attrs: {
      "isCanGet": _vm.isCanGet,
      "signId": _vm.signId
    }
  }), _vm._v(" "), _c('geted-number', {
    attrs: {
      "list": _vm.data
    }
  }), _vm._v(" "), _c('rule', {
    staticClass: "rule"
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app'
});

/***/ }),

/***/ 34:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(34)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(21),
  /* template */
  __webpack_require__(37),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 37:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "rule"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', [_vm._v("活动规则")]), _vm._v(" "), _c('span', [_vm._v("分享活动页面至微信群或朋友圈，即可与好友一起领取有道词典VIP会员")]), _vm._v(" "), _c('span', [_vm._v("每人可免费领取1个月VIP；6位好友通过你分享的页面成功领取VIP，你将可领取6个月VIP")]), _vm._v(" "), _c('span', [_vm._v("6个月VIP可以与1个月VIP叠加兑换，兑换第二个VIP码时需待上一VIP时限过期")]), _vm._v(" "), _c('span', [_vm._v("VIP码即日起至2019.06.30有效，请在有效期内兑换")]), _vm._v(" "), _c('span', [_vm._v("兑换路径：打开“有道词典”登录-我的-会员中心-兑换会员-输入VIP兑换码")])]), _vm._v(" "), _c('p', [_vm._v("Jirin 21 / Shin-Jirin, Japanese-Chinese EditionCopyright © 1993, 1999"), _c('br'), _vm._v(" by SANSEIDO CO., LTD.& Foreign Language Teaching and Research Publishing Co.,Ltd.")])])
}]}

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(125)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(76),
  /* template */
  __webpack_require__(143),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 76:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_GetCode__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_GetCode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_GetCode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GetedNumber__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GetedNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_GetedNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Rule__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Rule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Rule__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_util_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jsonp__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    data: function data() {
        return {
            data: '',
            signId: '',
            isCanGet: ''
        };
    },
    created: function created() {
        var that = this;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__libs_util_js__["a" /* initShareData */])(window.location.href, true);
        that.signId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__libs_util_js__["c" /* getParameter */])('signId');
        var url = 'http://ns014x.corp.youdao.com:12008/webutil/v2/dictVIP/showDictVIP?signId=' + that.signId;
        __WEBPACK_IMPORTED_MODULE_4_jsonp___default()(url, function (err, data) {
            if (data.code != 403) {
                that.data = data.result.friendInfoList;
                that.isCanGet = data.result.halfYear;
            }
        });
    },

    components: {
        GetCode: __WEBPACK_IMPORTED_MODULE_0__components_GetCode___default.a,
        GetedNumber: __WEBPACK_IMPORTED_MODULE_1__components_GetedNumber___default.a,
        Rule: __WEBPACK_IMPORTED_MODULE_2__components_Rule___default.a
    }
});

/***/ }),

/***/ 78:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clipboard__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_util_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Login__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Prompt__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Prompt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Prompt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jsonp__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jsonp__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'GetCode',
    data: function data() {
        return {
            isShowCode: false,
            code: '＊＊＊＊',
            canGet: 'canGet',
            noGet: 'noGet',
            couponType: '',
            showLogin: false,
            success: false,
            save: false,
            getSuccess: false,
            share: false,
            prompt: false,
            canGetSixMounthVip: true,
            canGetOneMounthVip: true
        };
    },

    props: {
        isCanGet: '',
        signId: ''
    },
    mounted: function mounted() {
        var oldCode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_util_js__["d" /* getStorage */])('code');
        if (oldCode != undefined) {
            this.isShowCode = true;
            this.code = oldCode;
        }
        this.signId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_util_js__["c" /* getParameter */])('signId');
        document.getElementsByClassName('mask')[0].addEventListener('touchmove', function (event) {
            event.preventDefault();
        }, false);
        document.getElementsByClassName('mask')[1].addEventListener('touchmove', function (event) {
            event.preventDefault();
        }, false);
    },

    components: {
        Login: __WEBPACK_IMPORTED_MODULE_2__Login___default.a,
        Prompt: __WEBPACK_IMPORTED_MODULE_3__Prompt___default.a
    },
    watch: {
        code: function code(val) {
            if (val != '＊＊＊＊') {
                this.success = true;
            }
        }
    },
    methods: {
        getOneMounthVip: function getOneMounthVip() {
            var that = this;
            this.couponType = '1';
            var url = void 0;
            window.ydk.isLogin({
                success: function success(res) {
                    if (!res.isLogin) {
                        that.showLogin = true;
                    } else {
                        __WEBPACK_IMPORTED_MODULE_4_jsonp___default()('http://ns014x.corp.youdao.com:12008/webutil/v2/dictVIP/getEncodedUserId', function (err, data) {
                            var url = void 0;
                            var signId = data.result.signId;
                            if (!ydk.isYD) {
                                url = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_util_js__["e" /* changeURLArg */])(window.location.href, 'signId', signId);
                            } else {
                                url = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_util_js__["e" /* changeURLArg */])('http://c.youdao.com/test/oxford-activity/index.html', 'signId', signId);
                            }
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_util_js__["a" /* initShareData */])(url, true);
                        });
                        if (that.signId == '') {
                            url = 'http://ns014x.corp.youdao.com:12008/webutil/v2/dictVIP/getCoupon?couponType=' + that.couponType;
                        } else {
                            url = 'http://ns014x.corp.youdao.com:12008/webutil/v2/dictVIP/getCoupon?couponType=' + that.couponType + '&signId=' + that.signId;
                        }
                        __WEBPACK_IMPORTED_MODULE_4_jsonp___default()(url, function (err, data) {
                            if (data.code != 503) {
                                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_util_js__["f" /* setStorage */])('code', that.code);
                                that.success = true;
                                that.canGetOneMounthVip = false;
                                that.code = data.data.coupon;
                                // that.prompt = true
                                // that.share = false
                                // that.getSuccess = true
                                // that.save = false
                            } else {
                                that.canGetOneMounthVip = false;
                                alert(data.reason);
                            }
                        });
                    }
                }
            });
        },
        getSixMounthVip: function getSixMounthVip() {
            var that = this;
            var url = 'http://ns014x.corp.youdao.com:12008/webutil/v2/dictVIP/halfYear?signId=' + this.signId;
            ydk.isLogin({
                success: function success(res) {
                    if (!res.isLogin) {
                        that.showLogin = true;
                    } else {
                        __WEBPACK_IMPORTED_MODULE_4_jsonp___default()('http://ns014x.corp.youdao.com:12008/webutil/v2/dictVIP/getEncodedUserId', function (err, data) {
                            var url = void 0;
                            var signId = data.result.signId;
                            if (!ydk.isYD) {
                                url = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_util_js__["e" /* changeURLArg */])(window.location.href, 'signId', signId);
                            } else {
                                url = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_util_js__["e" /* changeURLArg */])('http://c.youdao.com/test/oxford-activity/index.html', 'signId', signId);
                            }
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_util_js__["a" /* initShareData */])(url, true);
                        });
                        __WEBPACK_IMPORTED_MODULE_4_jsonp___default()(url, function (err, data) {
                            if (data.result.halfYear) {
                                that.isCanGet = false;
                                that.couponType = '6';
                                that.showCoupon();
                            } else {
                                if (that.$parent.data.length < 6) {
                                    that.prompt = true;
                                    that.share = true;
                                    that.getSuccess = false;
                                    that.save = false;
                                    that.canGetSixMounthVip = false;
                                } else {
                                    that.canGetSixMounthVip = false;
                                    alert("您已经领取过了");
                                }
                            }
                        });
                    }
                }
            });
        },
        showCoupon: function showCoupon(phone) {
            var that = this;
            var url = void 0;
            if (this.signId == '') {
                url = 'http://ns014x.corp.youdao.com:12008/webutil/v2/dictVIP/getCoupon?couponType=' + this.couponType;
            } else {
                url = 'http://ns014x.corp.youdao.com:12008/webutil/v2/dictVIP/getCoupon?couponType=' + this.couponType + '&signId=' + this.signId;
            }
            __WEBPACK_IMPORTED_MODULE_4_jsonp___default()(url, function (err, data) {
                that.code = data.data.coupon;
                that.prompt = true;
                that.share = false;
                that.getSuccess = false;
                that.save = true;
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_util_js__["f" /* setStorage */])('code', that.code);
                that.success = true;
            });
        },
        isLogin: function isLogin() {
            this.showLogin = false;
        },
        closed: function closed() {
            this.prompt = false;
        }
    }
});

/***/ }),

/***/ 79:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'GetedNumber',
    data: function data() {
        return {
            data: {}
        };
    },

    props: {
        list: {}
    }
});

/***/ }),

/***/ 80:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'GetCode',
    props: {
        showLogin: ''
    },
    methods: {
        goLogin: function goLogin() {
            window.location.href = 'http://c.youdao.com/dict/commons/login.html?back_url=' + encodeURIComponent(window.location.href);
        },
        closed: function closed() {
            this.$emit('isLogin');
        }
    }
});

/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'GetCode',
    props: {
        prompt: '',
        share: '',
        save: '',
        getSuccess: ''
    },
    methods: {
        closedMask: function closedMask() {
            this.$emit('closed');
        }
    }
});

/***/ }),

/***/ 82:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_index_css__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_index_css__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

var vue = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_1__App___default.a
  }
});

/***/ })

},[82]);


// WEBPACK FOOTER //
// static/js/app.js